<template>
  <modal>
    <div>
      <div class="modal-content">
        <h2 class="message text-center text-lg font-bold mb-2">旅行日程・便名等の基本設定</h2>
        <div class="message mb-2 text-center">
          <label>性別</label>
          <select v-model="sex" class="modal-select">
            <option v-for="sex in sexList" v-bind:key="sex.value" v-bind:value="sex.value">
              {{ sex.label }}
            </option>
          </select>
        </div>
        <div class="message mb-2 text-center">
          <label>年代</label>
          <select v-model="age" class="modal-select">
            <option v-for="age in ageList" v-bind:key="age.value" v-bind:value="age.value">
              {{ age.label }}
            </option>
          </select>
        </div>
        <div class="message mb-2 text-center">
          <label>往路便搭乗日</label>
          <input type="date" v-model="depDate" class="text-link_darker is-condition" @change="setFromFlights()">
        </div>
        <div class="message mb-2 text-center">
          <label>往路便名</label>
          <select v-model="depFlightNumber" class="modal-select">
            <option v-for="flight in depFlightList" v-bind:key="flight.number" v-bind:value="flight.number">
              {{ flight.name }}
            </option>
          </select>
        </div>
        <div class="message mb-2 text-center">
          <label>復路便搭乗日</label>
          <input type="date" v-model="arrDate" class="text-link_darker is-condition" @change="setFromFlights()">
        </div>
        <div class="message mb-2 text-center">
          <label>復路便名</label>
          <select v-model="arrFlightNumber" class="modal-select">
            <option v-for="flight in arrFlightList" v-bind:key="flight.number" v-bind:value="flight.number">
              {{ flight.name }}
            </option>
          </select>
        </div>
        <div class="message mb-2 text-center">
          <label>滞在地</label>
          <select v-model="stayPlace" class="modal-select">
            <option v-for="place in stayPlaces" v-bind:key="place.name" v-bind:value="place.name">
              {{ place.name }}
            </option>
          </select>
        </div>
        <div v-if="stayPlace === 'その他エリア(マップから検索して追加)'" class="text-sm">
          <div v-if="otherPlace !== undefined">
            滞在地：{{ otherPlace.name }}
          </div>
          <div v-else>
            滞在地：<span class="text-red">未設定</span>
          </div>
        </div>
        <div v-if="stayPlace === 'その他エリア(マップから検索して追加)'">
          <a @click="openMap">
            <img src="@/assets/images/icon-menu-map.svg" :alt="$t('map_label')" class="float-left" />
            <span class="ml-1">マップで入力検索して追加</span>
          </a>
        </div>
        <div class="message text-center">タクシー</div>
        <select v-model="useTaxi" class="modal-select">
          <option v-for="option in useOption" v-bind:key="option.name" v-bind:value="option.value">
            {{ option.name }}
          </option>
        </select>
        <div class="message text-center">バイクシェア</div>
        <select v-model="useCycle" class="modal-select">
          <option v-for="option in useOption" v-bind:key="option.name" v-bind:value="option.value">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="modal-button">
        <div v-if="this.$store.getters['user/getToken'] === null">
          <a class="button-primary block" @click="createToken">
            保存
          </a>
        </div>
        <div v-else-if="this.$store.getters['user/getProfile'] === null">
          <a class="button-primary block" @click="saveSetting">
            保存
          </a>
        </div>
        <div v-else>
          <div class="modal-button flex justify-between">
            <a @click="closePlanSetting" class="button-secondary block w-half">{{ $t('cancel') }}</a>
            <a @click="updateSetting" class="button-primary block w-half">
              更新
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.$store.getters['user/getToken'] !== null" class="border-t-2 border-gray-600 mt-2 pt-2">
      <div class="modal-content mt-2" v-if="this.$store.getters['user/getToken'] !== null">
        <span class="text-sm">リカバリーコード</span>：
        <span class="text-sm text-link_darker">{{ this.$store.getters['user/getRecoveryCode'] }}</span>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"
import Constants from '../../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    Modal
  },
  data () {
    return {
      depFlightList: [],
      arrFlightList: [],
      stayPlaces: [],
      depDate: "2020-12-01",
      arrDate: "2020-12-05",
      depFlightNumber: "JL74",
      arrFlightNumber: "JL71",
      stayPlace: "ワイキキ",
      otherPlace: undefined,
      useTaxi: true,
      useCycle: true,
      sex: null,
      age: null,
      useOption: [
        { name : "利用する", value : true },
        { name : "利用しない", value : false }
      ],
      sexList: [
        { label : "回答しない", value : null },
        { label : "女性", value : "female" },
        { label : "男性", value : "male" }
      ],
      ageList: [
        { label : "回答しない", value : null },
        { label : "10代", value : 10 },
        { label : "20代", value : 20 },
        { label : "30代", value : 30 },
        { label : "40代", value : 40 },
        { label : "50代", value : 50 },
        { label : "60代", value : 60 }
      ]
    };
  },
  created () {
    const now = moment()
    this.depDate = now.format('YYYY-MM-DD')
    this.arrDate = now.add(2, 'days').format('YYYY-MM-DD')
    this.setFromFlights()
    this.setToFlights()
  },
  mounted () {
    const places = this.$store.getters['places/getPlaces']
    for (let i = 0; i < places.length; i++) {
      if (places[i].genreIds[0] === "stay") {
        this.stayPlaces.push({
          id: places[i].id,
          name: places[i].name,
          lat: places[i].location.latitude,
          lng: places[i].location.longitude
        })
      }
    }
    //Placeからの指定
    this.stayPlaces.push({
      id: "etc",
      name: "その他エリア(マップから検索して追加)"
    })
    //デフォルト変更
    const changeProfile = this.$store.getters['user/getChangeProfile']
    if (changeProfile !== null) {
      this.depDate = changeProfile.depDate
      this.arrDate = changeProfile.arrDate
      this.depFlightNumber = changeProfile.depFlightNumber
      this.arrFlightNumber = changeProfile.arrFlightNumber
      this.stayPlace = changeProfile.stayPlace
      this.otherPlace = changeProfile.otherPlace
      this.useTaxi = changeProfile.useTaxi
      this.useCycle = changeProfile.useCycle
      this.sex = changeProfile.sex !== undefined ? changeProfile.sex : null
      this.age = changeProfile.age !== undefined ? changeProfile.age : null
    } else if (this.$store.getters['user/getProfile'] !== null) {
      const profile = Object.assign({}, this.$store.getters['user/getProfile'])
      this.depDate = profile.depDate
      this.arrDate = profile.arrDate
      this.depFlightNumber = profile.depFlightNumber
      this.arrFlightNumber = profile.arrFlightNumber
      this.stayPlace = profile.stayPlace
      this.otherPlace = profile.otherPlace
      this.useTaxi = profile.useTaxi
      this.useCycle = profile.useCycle
      this.sex = profile.sex !== undefined ? profile.sex : null
      this.age = profile.age !== undefined ? profile.age : null
      this.$store.dispatch('user/changeProfile', {profile: profile})
    }
  },
  methods: {
    createToken: function () {
      this.$gtag.event("滞在地設定", {
        stay_place: this.stayPlace,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.$store.getters['user/getToken']
      });
      const changeProfile = this.$store.getters['user/getChangeProfile']
      var otherPlace
      if (this.stayPlace === "その他エリア(マップから検索して追加)") {
        if (changeProfile === null || changeProfile.otherPlace === undefined || changeProfile.otherPlace === null) {
          this.$alert({ message: "マップで滞在地を検索して追加してください" })
          return
        } else {
          otherPlace = changeProfile.otherPlace
        }
      }
      this.$store.dispatch('loading/beginLoading')
      this.closePlanSetting()
      this.$store.dispatch('plans/createToken')
        .then(() => {
          this.$store.dispatch('user/updateProfile', this.getParams(otherPlace))
            .then(() => {
              this.$store.dispatch('user/clearChangeProfile')
            })
            .finally(() => {
              this.$store.dispatch('loading/endLoading')
            })
        })
    },
    setFromFlights: function () {
      this.depFlightList.splice(0)
      let fromFlights = this.$store.getters['flight/getFlight'](this.depDate)
      for (let i = 0; i < fromFlights.timetable.length; i++) {
        if (fromFlights.timetable[i].fromName !== "ホノルル") {
          this.depFlightList.push({
            number: fromFlights.timetable[i].number,
            name: fromFlights.timetable[i].number + "(" + fromFlights.timetable[i].fromName + "発)" + " " + fromFlights.timetable[i].departure + "～" + fromFlights.timetable[i].arrival,
            default: fromFlights.timetable[i].default
          })
        }
      }
      if (this.depFlightList.find(f => f.number === this.depFlightNumber) === undefined) {
        this.depFlightNumber = this.depFlightList.find(f => f.default === "true").number
      }
    },
    setToFlights: function () {
      this.arrFlightList.splice(0)
      let toFlights = this.$store.getters['flight/getFlight'](this.arrDate)
      for (let i = 0; i < toFlights.timetable.length; i++) {
        if (toFlights.timetable[i].fromName === "ホノルル") {
          this.arrFlightList.push({
            number: toFlights.timetable[i].number,
            name: toFlights.timetable[i].number + "(" + toFlights.timetable[i].toName + "着)" + " " + toFlights.timetable[i].departure + "～" + toFlights.timetable[i].arrival,
            default: toFlights.timetable[i].default
          })
        }
      }
      if (this.arrFlightList.find(f => f.number === this.depFlightNumber) === undefined) {
        this.arrFlightNumber = this.arrFlightList.find(f => f.default === "true").number
      }
    },
    saveSetting: function () {
      this.$gtag.event("滞在地設定", {
        stay_place: this.stayPlace,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.$store.getters['user/getToken']
      });
      const changeProfile = this.$store.getters['user/getChangeProfile']
      var otherPlace
      if (this.stayPlace === "その他エリア(マップから検索して追加)") {
        if (changeProfile === null || changeProfile.otherPlace === undefined || changeProfile.otherPlace === null) {
          this.$alert({ message: "マップで滞在地を検索して追加してください" })
          return
        } else {
          otherPlace = changeProfile.otherPlace
        }
      }
      this.$store.dispatch('loading/beginLoading')
      this.closePlanSetting()
      this.$store.dispatch('user/updateProfile', this.getParams(otherPlace))
        .then(() => {
          this.$store.dispatch('user/clearChangeProfile')
        })
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    },
    updateSetting: function () {
      this.$gtag.event("滞在地設定", {
        stay_place: this.stayPlace,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.$store.getters['user/getToken']
      });
      const changeProfile = this.$store.getters['user/getChangeProfile']
      var otherPlace
      if (this.stayPlace === "その他エリア(マップから検索して追加)") {
        if (changeProfile.otherPlace === undefined || changeProfile.otherPlace === null) {
          this.$alert({ message: "マップで滞在地を検索して追加してください" })
          return
        } else {
          otherPlace = changeProfile.otherPlace
        }
      } else {
        this.$store.dispatch('user/clearStayPlace')
      }
      this.$store.dispatch('loading/beginLoading')
      this.closePlanSetting()
      this.$store.dispatch('user/updateProfile', this.getParams(otherPlace))
        .then(() => {
          this.$store.dispatch('user/clearChangeProfile')
        })
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    },
    openMap: function () {
      const changeProfile = this.$store.getters['user/getChangeProfile']
      const params = {
        profile: {
          depDate: this.depDate,
          arrDate: this.arrDate,
          depFlightNumber: this.depFlightNumber,
          arrFlightNumber: this.arrFlightNumber,
          stayPlace: this.stayPlace,
          otherPlace: changeProfile !== null ? changeProfile.otherPlace : undefined,
          useTaxi: this.useTaxi,
          useCycle: this.useCycle,
          sex: this.sex,
          age: this.age
        }
      }
      this.$store.dispatch('user/changeProfile', params)
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'] } })
    },
    closePlanSetting: function () {
      this.$store.dispatch('user/clearChangeProfile')
      this.$emit('closePlanSetting')
    },
    getParams: function (otherPlace){
      const params = {
        token: this.$store.getters['user/getToken'],
        id: Constants.API_ID,
        profile: {
          depDate: this.depDate,
          arrDate: this.arrDate,
          depFlightNumber: this.depFlightNumber,
          arrFlightNumber: this.arrFlightNumber,
          stayPlace: this.stayPlace,
          otherPlace: otherPlace,
          useTaxi: this.useTaxi,
          useCycle: this.useCycle,
          sex: this.sex,
          age: this.age
        }
      }
      return params
    }
  }
}
</script>
